import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cart-checkout__messages"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_ctx.status.messages)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status.messages, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(['alert d-flex align-items-center pt-2 pb-2', message.style ? 'alert-' + message.style : 'alert-warning', !message.persistent ? 'alert-dismissible' : '']),
                    role: "alert"
                }, [
                    (message.iconUrl)
                        ? (_openBlock(), _createBlock(_component_g_icon, {
                            key: 0,
                            class: "flex-shrink-0 me-2",
                            width: "24",
                            height: "24",
                            src: message.iconUrl,
                            "aria-label": "Warning:"
                        }, null, 8, ["src"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        innerHTML: message.description
                    }, null, 8, _hoisted_2),
                    (!message.persistent)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn-close p-0",
                            style: { "padding-top": "1.5rem !important", "padding-right": "1.5rem !important" },
                            "aria-label": "Close",
                            onClick: ($event) => (_ctx.cmdRemoveMessage(message))
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true)
                ], 2));
            }), 256))
        ]))
        : _createCommentVNode("", true);
}
